import type { GapsDetailed } from '../../types/analysis.types';

export const vibeMapperGapsDetailed: GapsDetailed = {
  missing: [
    {
      id: 'missing1',
      title: 'No vulnerability scanning',
      description:
        'No tool (Snyk, Trivy, npm audit, pip-audit) scans dependencies for known CVEs in the CI pipeline.',
      severity: 'critical',
      category: 'security',
      evidence: ['.gitlab-ci.yml'],
    },
    {
      id: 'missing2',
      title: 'No SAST tool',
      description:
        'No static application security testing tool configured to detect code-level vulnerabilities.',
      severity: 'high',
      category: 'security',
      evidence: ['.gitlab-ci.yml'],
    },
    {
      id: 'missing3',
      title: 'No secret detection tool',
      description:
        'No Gitleaks, TruffleHog, or similar tool to prevent secrets from being committed.',
      severity: 'high',
      category: 'security',
      evidence: ['.pre-commit-config.yaml'],
    },
    {
      id: 'missing4',
      title: 'No PR/MR template',
      description:
        'No merge request template to standardize descriptions, testing checklists, and review criteria.',
      severity: 'high',
      category: 'collaboration',
      evidence: ['.gitlab/'],
    },
    {
      id: 'missing5',
      title: 'No dependency automation',
      description: 'No Dependabot or Renovate configured. 240 of 370 dependencies are outdated.',
      severity: 'medium',
      category: 'build',
      evidence: ['package.json', 'requirements.txt'],
    },
  ],
  incomplete: [
    {
      category: 'testing',
      practice: 'Coverage enforcement',
      currentState:
        'Coverage threshold is configured in the test setup, but CI does not fail when coverage drops below the threshold.',
      targetState:
        'CI pipeline fails when code coverage drops below the configured threshold, preventing regressions.',
      effort: 'medium',
    },
    {
      category: 'cicd',
      practice: 'Continuous deployment',
      currentState:
        'CI runs build and test stages. Deployments to staging and production require manual triggers.',
      targetState:
        'Automated deployment to staging on merge to main, with manual promotion to production.',
      effort: 'medium',
    },
  ],
  risks: [
    {
      category: 'security',
      risk: 'Hardcoded secrets in repository history',
      probability: 'medium',
      impact: 'Credentials could be extracted from git history, leading to unauthorized access.',
      mitigation:
        'Run Gitleaks baseline scan, rotate any discovered secrets, and add pre-commit hooks.',
    },
    {
      category: 'build',
      risk: 'High dependency drift increases vulnerability exposure',
      probability: 'high',
      impact:
        '240 outdated dependencies may contain unpatched CVEs. No scanning means vulnerabilities go undetected.',
      mitigation: 'Adopt Renovate for automated updates and add vulnerability scanning to CI.',
    },
  ],
};
